import React from "react";
import { Link } from "react-router-dom";
import PageHero, { usePageMeta } from "@/components/marketing/PageHero";
import Reveal from "@/components/marketing/Reveal";
import { Button } from "@/components/ui/button";
import { getHowSteps, getSecurityPoints, getCompliance } from "@/data/site";
import { ShieldCheck } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function ComeFunziona() {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  usePageMeta(L("Come funziona", "How it works", "So funktioniert es"), L("Il processo di Recovers Crypto in tre passaggi.", "The Recovers Crypto process in three steps.", "Der Recovers-Crypto-Prozess in drei Schritten."));
  const steps = getHowSteps(lang);
  const security = getSecurityPoints(lang);
  const compliance = getCompliance(lang);
  return (
    <div>
      <PageHero eyebrow={L("Come funziona", "How it works", "So funktioniert es")} title={L("Un processo chiaro e documentato", "A clear and documented process", "Ein klarer und dokumentierter Prozess")}
        subtitle={L("Dalla valutazione iniziale alla consegna, ogni fase è definita per iscritto e gestita con accesso controllato.", "From the initial assessment to delivery, every stage is defined in writing and managed with controlled access.", "Von der ersten Bewertung bis zur Übergabe wird jede Phase schriftlich festgelegt und mit kontrolliertem Zugriff verwaltet.")} />
      <section className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="space-y-6">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div className="flex gap-6 rounded-xl border border-white/10 bg-navy-paper p-7">
                <span className="font-heading text-4xl font-light text-gold/40 shrink-0">{s.n}</span>
                <div>
                  <h3 className="font-heading text-xl font-medium text-white">{s.title}</h3>
                  <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16">
          <h2 className="font-heading text-2xl font-medium text-white mb-6">{L("Sicurezza in ogni fase", "Security at every stage", "Sicherheit in jeder Phase")}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {security.map((p) => (
              <div key={p} className="flex items-center gap-2.5 text-sm text-slate-300"><ShieldCheck className="h-4 w-4 text-cyanx shrink-0" />{p}</div>
            ))}
          </div>
        </div>

        <div className="mt-16">
          <h2 className="font-heading text-2xl font-medium text-white mb-6">{L("Posizionamento etico", "Ethical positioning", "Ethische Positionierung")}</h2>
          <ul className="space-y-2.5">
            {compliance.map((c) => (
              <li key={c} className="text-sm text-slate-400 leading-relaxed border-l-2 border-white/10 pl-4">{c}</li>
            ))}
          </ul>
        </div>

        <div className="mt-14 flex justify-center">
          <Button asChild size="lg" className="bg-gold text-navy hover:bg-gold-hover"><Link to="/avvia-recupero">{L("Richiedi una valutazione", "Request an assessment", "Bewertung anfragen")}</Link></Button>
        </div>
      </section>
    </div>
  );
}
